export default {"src":"/_next/static/media/app-mobile-entertainment.ee833618.svg","height":192,"width":192};